/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyUnlockOperations: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-unlock-operations", jiraSpaEntry: "async-jira-eoc-unlock-operations" */ '@jira/eoc__unlock-operations/src/index.tsx'
		),
);

const AsyncUnlockOperations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyUnlockOperations}
		pageId="eoc-products-unlock-operations"
		shouldShowSpinner={false}
	/>
);

export default AsyncUnlockOperations;
